import { isPathLookupEdgeData } from '@ipfabric/utils';
import type { PacketDetailMouseEvent } from 'components/DeviceView/DeviceViewContent/PacketDetail/PacketDetail';
import {
  EDGE_HIGHLIGHT_THICKNESS,
  FOLLOWING_EDGE_HIGHLIGHT_COLOR,
} from 'components/Graph/constants';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { highlightEdges } from '../pathLookup/highlightEdges';

export const pathLookupDetailNextButtonMouseEnter: GraphCommandFactory<
  PacketDetailMouseEvent
> = (cmdContext, dispatch) => (command) => {
  const foundEdge = cmdContext.getState().graph.edges[command.detailId];
  if (foundEdge === undefined || !isPathLookupEdgeData(foundEdge)) {
    return;
  }

  dispatch(highlightEdges, {
    edges: foundEdge.nextEdgeIds,
    color: FOLLOWING_EDGE_HIGHLIGHT_COLOR,
    thickness: EDGE_HIGHLIGHT_THICKNESS,
  });
};
